import React from 'react'
// Swiper
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import SwiperCore from 'swiper'
// Modules
import 'swiper/css/mousewheel'
import { Mousewheel, FreeMode } from 'swiper/modules'
// Custom
import './styles.css'
// Modules usage
SwiperCore.use([Mousewheel, FreeMode])

export const CarouselSlide = SwiperSlide

function Carousel({ slides, ...props }) {

  const preventVerticalScroll = (event) => {
    const { deltaX, deltaY } = event;

    // Calculate vertical ratio (how much of the movement is vertical)
    const ratio = Math.abs(deltaY) / (Math.abs(deltaX) + Math.abs(deltaY));

    // Allow only swipes where vertical movement is less than 15%
    if (ratio < 0.15) {
      event.preventDefault();
    }
  };

  return (
    <Swiper
      {...props}
      direction="horizontal"
      mousewheel={{ forceToAxis: true, sensitivity: 1 }}
      freeMode={false}
      onWheelCapture={preventVerticalScroll}
    >
      {slides.map((s, i) => s)}
    </Swiper>
  )
}

export default Carousel
